import { useEffect, useState } from 'react';

type AppInitGateProps = {
  children: React.ReactNode;
  init: () => Promise<void>;
};

export function AppInitGate({ children, init }: AppInitGateProps) {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    async function initApp() {
      await init();
      setIsInitialized(true);
    }
    initApp();
  }, [init]);

  return isInitialized ? children : null;
}
